const SUPPLIER_SHARE_BASE_DEFAULT_FILTERS = {
  productQuery: '',
  customerName: '',
  startDate: '',
  endDate: '',
  supplierResponseDueDateNullOnly: false,
  supplierResponseDueDateSetOnly: false,
  /** 依頼書発行済（一部含む） */
  shipRequestIssuedOnly: false,
  hacchuDateFromToday: false,
  currentPeriodOnly: true,
  previousPeriodsOnly: false,
  /** 納入先に「大垣工場」を含むもののみ（宝機材向け・デフォルトOFF） */
  ogakiFactoryOnly: false,
  /** 備考に「本日発送」かつ依頼書発行日が今日（デフォルトOFF） */
  todayShipOnly: false,
};

/** 仕入先共有（参照）画面のデフォルト検索条件 */
export const SUPPLIER_SHARE_DEFAULT_FILTERS = {
  ...SUPPLIER_SHARE_BASE_DEFAULT_FILTERS,
  /** 依頼書未発行のみ ※参照ページ専用 */
  shipRequestUnissuedOnly: false,
  filterSupplierCode: null,
  excludeSupplierCodes: null,
  jukuwakuFilter: false,
};

/** 仕入先共有（編集）画面のデフォルト検索条件 */
export const SUPPLIER_SHARE_EDIT_DEFAULT_FILTERS = {
  ...SUPPLIER_SHARE_BASE_DEFAULT_FILTERS,
};

/**
 * URLSearchParams から仕入先共有（参照）のフィルタ状態を構築する。
 * @param {URLSearchParams} searchParams
 */
export function buildSupplierShareFiltersFromSearchParams(searchParams) {
  return {
    ...SUPPLIER_SHARE_DEFAULT_FILTERS,
    productQuery: searchParams.get('product_query') || '',
    customerName: searchParams.get('customer_name') || '',
    startDate: searchParams.get('start_date') || '',
    endDate: searchParams.get('end_date') || '',
    supplierResponseDueDateNullOnly: searchParams.get('supplier_response_due_date_null_only') === 'true',
    supplierResponseDueDateSetOnly: searchParams.get('supplier_response_due_date_set_only') === 'true',
    shipRequestUnissuedOnly: searchParams.get('ship_request_unissued_only') === 'true',
    shipRequestIssuedOnly: searchParams.get('ship_request_issued_only') === 'true',
    hacchuDateFromToday: searchParams.get('hacchu_date_from_today') === 'true',
    currentPeriodOnly: searchParams.get('current_period_only') !== 'false',
    previousPeriodsOnly: searchParams.get('previous_periods_only') === 'true',
    jukuwakuFilter: searchParams.get('jukuwaku_filter') === 'true',
    ogakiFactoryOnly: searchParams.get('ogaki_factory_only') === 'true',
    todayShipOnly: searchParams.get('today_ship_only') === 'true',
  };
}

/**
 * URLSearchParams から仕入先共有（編集）のフィルタ状態を構築する。
 * @param {URLSearchParams} searchParams
 */
export function buildSupplierShareEditFiltersFromSearchParams(searchParams) {
  return {
    ...SUPPLIER_SHARE_EDIT_DEFAULT_FILTERS,
    productQuery: searchParams.get('product_query') || '',
    customerName: searchParams.get('customer_name') || '',
    startDate: searchParams.get('start_date') || '',
    endDate: searchParams.get('end_date') || '',
    supplierResponseDueDateNullOnly: searchParams.get('supplier_response_due_date_null_only') === 'true',
    supplierResponseDueDateSetOnly: searchParams.get('supplier_response_due_date_set_only') === 'true',
    shipRequestIssuedOnly: searchParams.get('ship_request_issued_only') === 'true',
    hacchuDateFromToday: searchParams.get('hacchu_date_from_today') === 'true',
    currentPeriodOnly: searchParams.get('current_period_only') !== 'false',
    previousPeriodsOnly: searchParams.get('previous_periods_only') === 'true',
    ogakiFactoryOnly: searchParams.get('ogaki_factory_only') === 'true',
    todayShipOnly: searchParams.get('today_ship_only') === 'true',
  };
}

/**
 * 参照画面のフィルタから、編集画面へ引き継ぐクエリ文字列を作る。
 * 参照専用（jukuwaku・未発行のみ 等）は載せない。
 * @param {object} filters
 * @returns {string} 先頭 ? なし（空なら空文字）
 */
export function buildSupplierShareEditQueryFromViewFilters(filters = {}) {
  const params = new URLSearchParams();
  if (filters.productQuery) {
    params.set('product_query', filters.productQuery);
  }
  if (filters.customerName) {
    params.set('customer_name', filters.customerName);
  }
  if (filters.startDate) {
    params.set('start_date', filters.startDate);
  }
  if (filters.endDate) {
    params.set('end_date', filters.endDate);
  }
  if (filters.supplierResponseDueDateNullOnly) {
    params.set('supplier_response_due_date_null_only', 'true');
  }
  if (filters.supplierResponseDueDateSetOnly) {
    params.set('supplier_response_due_date_set_only', 'true');
  }
  if (filters.shipRequestIssuedOnly) {
    params.set('ship_request_issued_only', 'true');
  }
  if (filters.hacchuDateFromToday) {
    params.set('hacchu_date_from_today', 'true');
  }
  if (filters.currentPeriodOnly) {
    params.set('current_period_only', 'true');
  } else if (filters.previousPeriodsOnly) {
    params.set('previous_periods_only', 'true');
  }
  if (filters.ogakiFactoryOnly) {
    params.set('ogaki_factory_only', 'true');
  }
  if (filters.todayShipOnly) {
    params.set('today_ship_only', 'true');
  }
  return params.toString();
}
